import isUrl from 'is-url';

const getRequiredValidation = (
  requiredValidationMessage,
) => ({
  required: requiredValidationMessage,
});

const getEmailValidation = (
  emailValidationMessage,
  requiredValidationMessage,
) => ({
  required: requiredValidationMessage,
  pattern: {
    message: emailValidationMessage,
    // eslint-disable-next-line max-len
    value: /^([\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?)*)?$/,
  },
});

const getPasswordValidation = (
  passwordTooShortMessage,
  requiredValidationMessage,
) => ({
  required: requiredValidationMessage,
  minLength: {
    value: 12,
    message: passwordTooShortMessage,
  },
});

const getUrlValidation = (
  urlValidationMessage,
  requiredValidationMessage,
  allowRelative = false,
) => ({
  required: requiredValidationMessage,
  validate: (value) => (
    !value
    || isUrl(value)
    || (allowRelative && /^\//.test(value))
    || urlValidationMessage
  ),
});

const getApplyUrlValidation = (
  urlValidationMessage,
  requiredValidationMessage,
  showApplyUrl,
) => ({
  validate: (value) => (value
    ? isUrl(value) || urlValidationMessage
    : !showApplyUrl || requiredValidationMessage
  ),
});

const getSlugValidation = () => ({
  pattern: {
    message: 'Slugs must use only lowercase characters, number and hyphens',
    value: /^[\da-z-]+$/,
  },
});

export {
  getRequiredValidation,
  getEmailValidation,
  getPasswordValidation,
  getUrlValidation,
  getApplyUrlValidation,
  getSlugValidation,
};
